import { render, staticRenderFns } from "./PopupAddCompositeFolder.vue?vue&type=template&id=24b6e9c3"
import script from "./PopupAddCompositeFolder.vue?vue&type=script&lang=ts"
export * from "./PopupAddCompositeFolder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports